// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k24B","type":"styles_type__1lJX2","choices":"styles_choices__1rXSf"};